// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: true,
  cerf: true,
  baseUrl: 'https://api.dnatausa.us/api/',
  callbackURL: 'https://cerf.dnatausa.us/callback',
  apiUrl: 'http://localhost',
  silentUrl: 'https://cerf.dnatausa.us/silent',
  appUrl: 'https://cerf.dnatausa.us',
  auth0ClientID: 'NUo0U5FdJ6tm8wbh8Gi2TJiwua050XRO',
  auth0Domain: 'lougeek.auth0.com',
  auth0Audience: 'https://api.dnatausa.us/api'
};



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/environments/environment.ts